<mat-accordion [displayMode]="'flat'">
  <mat-expansion-panel [expanded]="true">
    <h5>
      {{ 'reset-password.title' | translate }}
    </h5>
    <div class="content">
      <ng-container *ngIf="!success; else passwordResetSuccess">
        <form class="form-container" [formGroup]="resetForm">
          <mat-form-field appearance="outline" id="password1">
            <mat-label>{{ 'reset-password.password' | translate }}</mat-label>
            <input
              matInput
              [type]="isPasswordVisible[0] ? 'text' : 'password'"
              formControlName="password1"
              #password1
              (keydown.enter)="submitReset(password1.value, password2.value)"
            />
            <mat-icon matSuffix (click)="togglePasswordVisibility(0)">{{
              isPasswordVisible[0] ? 'password' : 'remove_red_eye'
            }}</mat-icon>
            <mat-error *ngIf="resetForm?.get('password1')?.hasError('required')">
              ⚠️&nbsp;{{ 'reset-password.error.mandatory' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" id="password2">
            <mat-label>{{ 'reset-password.password-again' | translate }}</mat-label>
            <input
              matInput
              [type]="isPasswordVisible[1] ? 'text' : 'password'"
              formControlName="password2"
              #password2
              (keydown.enter)="submitReset(password1.value, password2.value)"
            />
            <mat-icon matSuffix (click)="togglePasswordVisibility(1)">{{
              isPasswordVisible[1] ? 'password' : 'remove_red_eye'
            }}</mat-icon>
            <mat-error *ngIf="resetForm?.get('password2')?.hasError('mismatch')">
              ⚠️&nbsp;{{ 'reset-password.error.mismatch' | translate }}
            </mat-error>
          </mat-form-field>
        </form>
        <button class="btn-primary" (click)="submitReset(password1.value, password2.value)" [disabled]="isSubmitting">
          {{ 'reset-password.submit' | translate }}
        </button>
      </ng-container>
      <ng-template #passwordResetSuccess>
        <p>✅&nbsp;{{ 'reset-password.success' | translate }}</p>
      </ng-template>
    </div>
  </mat-expansion-panel>
</mat-accordion>
